import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { types, actions } from './reducer';
import { extractError } from '@iso/lib//helpers/api';
import CategoryService from '@iso/services/SettingsService/ProductService/CategoryService';

function* viewCategory({ id }) {
    try {
        const response = yield call(CategoryService.getOne, id);
        yield put(actions.viewCategorySucceeded(response.data));
    } catch (error) {
        yield put(actions.viewCategoryFailed(extractError(error)));
    }
}

function* watchViewCategory() {
    yield takeEvery(
        types.REQUEST_VIEW_CATEGORY,
        viewCategory,
    );
}

function* viewSaga() {
    yield all([
        fork(watchViewCategory),
    ]);
}

export default viewSaga;
